/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1710
 */

"use strict"

var r = require(/* 951 */"../1779/951")
var o = require(/* 1258 */"./1258")
module.exports = r("Set", function (e) {
  return function () {
    return e(this, arguments.length ? arguments[0] : undefined)
  }
}, o)
